import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import format from 'date-fns/format';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    auth: state.auth,
    summary: state.summary,
    userData: state.userData,
    merchants: state.merchants,
    transactionQuery: state.transactionQuery,
    walletQuery: state.walletQuery,
    transactions: state.transactions,
    walletLogs: state.walletLogs,
    activeBusiness: state.activeBusiness,
    acl: state.acl,
    isLive: false,
    isSalesChartLoading: state.isSalesChartLoading,
    isPerformanceChartLoading: state.isPerformanceChartLoading,
    isSummaryCardLoading: state.isSummaryCardLoading,
    webhookHistory: state.webhookHistory,
  }),
});

Vue.use(Vuex);

const initialState = {
  auth: {
    loggedIn: false,
    token: '',
    exp: 0,
  },
  activeBusiness: null,
  breakDown: [
    { count: 0, sum: 0, disco: 'ABUJA' },
    { count: 0, sum: 0, disco: 'EKO' },
    { count: 0, sum: 0, disco: 'ENUGU' },
    { count: 0, sum: 0, disco: 'IBADAN' },
    { count: 0, sum: 0, disco: 'IKEJA' },
    { count: 0, sum: 0, disco: 'JOS' },
    { count: 0, sum: 0, disco: 'KADUNA' },
    { count: 0, sum: 0, disco: 'KANO' },
  ],
  summary: {
    wallet: 0,
    transactions: {
      amount: 0,
      volume: 0,
    },
    totalCommission: 0,
    commission: 0,
  },
  userData: {
    wallet: 0,
  },
  merchants: [],
  selectedMerchant: {},
  transactionQuery: {
    orderId: '',
    merchantId: '',
    page: 1,
    limit: 15,
    start: format(new Date(), 'YYYY-MM-DD'),
    end: format(new Date(), 'YYYY-MM-DD'),
  },
  transactions: [],
  walletQuery: {
    page: 1,
    limit: 20,
    start: format(new Date(), 'YYYY-MM-DD'),
    end: format(new Date(), 'YYYY-MM-DD'),
  },
  loading: false,
  transactionModalOpen: false,
  walletLogs: [],
  totalMerchantPages: 0,
  transactionDetail: {},
  acl: {},
  sales: {
    xAxis: [],
    yAxis: [],
  },
  performance: [],
  queryInterval: 'DAY',
  filterBy: 'DAY',
  bankAccounts: [],
  isSalesChartLoading: false,
  isPerformanceChartLoading: false,
  isSummaryCardLoading: false,
  webhookHistory: [],
  batchOrders: [],
};

const store = new Vuex.Store({
  state: initialState,
  mutations: {
    authState(state, data = { loggedIn: false, token: '', exp: 0 }) {
      state.auth = data;
    },
    userDataState(state, data = {}) {
      state.userData = data;
    },
    busyStatus(state, status = false) {
      state.loading = status;
    },
    setIsSalesChartLoading(state, isSalesChartLoading = false) {
      state.isSalesChartLoading = isSalesChartLoading;
    },
    setIsPerformanceChartLoading(state, isPerformanceChartLoading = false) {
      state.isPerformanceChartLoading = isPerformanceChartLoading;
    },
    setIsSummaryCardLoading(state, isSummaryCardLoading = false) {
      state.isSummaryCardLoading = isSummaryCardLoading;
    },
    setSummary(state, summary) {
      state.summary = summary;
    },
    setIsLive(state, isLive) {
      state.isLive = isLive;
    },
    setActiveBusiness(state, business) {
      state.activeBusiness = business;
    },
    setAcl(state, acl) {
      state.acl = acl;
    },
    setSales(state, sales) {
      state.sales = sales;
    },
    setPerformance(state, performance) {
      state.performance = performance;
    },
    setQueryInterval(state, queryInterval) {
      state.queryInterval = queryInterval;
    },
    setFilterBy(state, filterBy) {
      state.filterBy = filterBy;
    },
    setBankAccounts(state, bankAccounts) {
      state.bankAccounts = bankAccounts;
    },
    setTransactions(state, transactions) {
      state.transactions = transactions;
    },
    setTransactionDetails(state, transactionDetail) {
      state.transactionDetail = transactionDetail;
    },
    setTxnModal(state, open = false) {
      state.transactionModalOpen = open;
    },
    setTransactionQuery(state, transactionQuery) {
      state.transactionQuery = transactionQuery;
    },
    setWalletQuery(state, walletQuery) {
      state.walletQuery = walletQuery;
    },
    setMerchants(state, merchants) {
      state.merchants = merchants;
    },
    setWalletLogs(state, walletLogs) {
      state.walletLogs = walletLogs;
    },
    resetState() {
      store.replaceState({
        ...initialState,
        activeBusiness: store.state.activeBusiness,
      });
    },
    setMerchant(state, merchant) {
      state.selectedMerchant = merchant;
    },
    setBreakDown(state, data) {
      state.breakDown = data;
    },
    setWebhookHistory(state, data) {
      state.webhookHistory = data;
    },
    setBatchOrders(state, data) {
      state.batchOrders = data;
    }
  },
  getters: {
    allBreakDownOfTransactions: (state) => state.breakDown,
  },
  actions: {},
  plugins: [vuexLocal.plugin],
});

export default store;
